import { Button, PageTitle } from 'hem-ui';
import React from 'react';

export const PreOrderLogIn = ({ location }: { location: Location }) => {
  const sendGtmApplyForAccountEvent = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'pro_account_signup_step2',
      });
    }
  };

  return (
    <PageTitle
      topTitle="Exclusive preview for Hem Pro members"
      title="Pre-order products are only available to Hem Pro members"
      subtitle="Log in or create an account"
      bottom={
        <div className="flex flex-col items-center justify-center gap-2 md:flex-row md:gap-4">
          <Button
            to="/login"
            // @ts-expect-error ...rest is spread on a button-styled Link
            state={{ from: location.pathname }}
            className="w-full md:w-auto"
          >
            Log in to Hem Pro
          </Button>
          <Button
            to="/hem-pro/signup"
            onClick={sendGtmApplyForAccountEvent}
            color="white-with-blue-border"
            className="w-full md:w-auto"
          >
            Apply for an account
          </Button>
        </div>
      }
    />
  );
};
